import { Component } from '@angular/core';
import { CMSService } from '../Services/cms.service';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { CmsLoginDealsProperties } from '../Models/CmsLoginDealsProperties';
import * as $ from 'jquery';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-cms-sub-deals',
  templateUrl: './cms-sub-deals.component.html',
  styleUrls: ['./cms-sub-deals.component.css']
})
export class CmsSubDealsComponent {
  constructor(private userService: CMSService, public cmsService: CMSService, private http: HttpClient) { }
  cmsDealsObj = new CmsLoginDealsProperties();
  baseUrl = environment.baseUrl;
  public progress: number;
  public message: string;
  public imagePath: string;
  public responseMessage: string;
  public uploadFile = (files) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.http.post(this.baseUrl + '/CmsLogin/SaveDealsImages', formData, { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          this.imagePath = event.body.toString();
          this.message = 'Uploaded Successfully...';
          //this.onUploadFinished.emit(event.body);
        }
      });
  }
  ngOnInit() {
    this.LoadEditableData();
  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("serialNo") != undefined || localStorage.getItem("serialNo") != null) {
        let sr = Number(localStorage.getItem("serialNo"));
        if (sr != 0 || sr != undefined) {
          this.userService.getDealsById(sr).subscribe((data) => {
            this.cmsDealsObj = data[0] as CmsLoginDealsProperties;
            localStorage.removeItem("serialNo");
          });
        }
      }
    }
    catch (e) {
      ////console.log (e);
    }
  }
  onSubmit() {
    if (this.cmsDealsObj.sr == 0 || this.cmsDealsObj.sr == null) {
      this.cmsDealsObj.dealImage = this.imagePath;
      this.userService.createDeals(this.cmsDealsObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data inserted Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }
    else {
      this.cmsDealsObj.dealImage = this.imagePath;
      this.userService.updateDeals(this.cmsDealsObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data updated Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while updating data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }
  }
  cancel() {
    this.cmsDealsObj = new CmsLoginDealsProperties();
  }
}
